const FRANCHISE_SWITCH_EVENT_KEY = 'driveato:franchise-switch:event';
const FRANCHISE_TAB_ID_KEY = 'driveato:franchise-switch:tab-id';

const generateTabId = () =>
  `tab-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

const getTabId = () => {
  if (!window.sessionStorage) {
    return generateTabId();
  }

  const existing = window.sessionStorage.getItem(FRANCHISE_TAB_ID_KEY);
  if (existing) {
    return existing;
  }

  const created = generateTabId();
  window.sessionStorage.setItem(FRANCHISE_TAB_ID_KEY, created);
  return created;
};

const parseBroadcast = (rawValue) => {
  if (!rawValue) return null;

  try {
    return JSON.parse(rawValue);
  } catch (_) {
    return null;
  }
};

const installFranchiseTabGuard = () => {
  const guardNode = document.querySelector('[data-franchise-tab-guard="true"]');
  if (!guardNode) return;

  const currentSchoolToken = guardNode.dataset.currentSchoolToken;
  if (!currentSchoolToken) return;

  const tabId = getTabId();
  const overlay = document.getElementById('franchise-tab-lock-overlay');
  const switchForm = document.querySelector('form[data-franchise-switch-form="true"]');

  if (switchForm && !switchForm.dataset.franchiseSwitchBound) {
    switchForm.addEventListener('submit', () => {
      const select = switchForm.querySelector('select[name="token"]');
      if (!select || !select.value) return;

      const selectedOption = select.options[select.selectedIndex];
      const payload = {
        tabId,
        schoolToken: select.value,
        schoolName: selectedOption ? selectedOption.text : null,
        switchedAtMs: Date.now()
      };

      window.localStorage.setItem(FRANCHISE_SWITCH_EVENT_KEY, JSON.stringify(payload));
    });
    switchForm.dataset.franchiseSwitchBound = 'true';
  }

  window.addEventListener('storage', (event) => {
    if (event.key !== FRANCHISE_SWITCH_EVENT_KEY || !event.newValue) return;

    const payload = parseBroadcast(event.newValue);
    if (!payload || payload.tabId === tabId) return;
    if (payload.schoolToken === currentSchoolToken) return;

    if (overlay) {
      overlay.style.display = 'block';
    }
  });
};

document.addEventListener('DOMContentLoaded', installFranchiseTabGuard);
document.addEventListener('turbo:load', installFranchiseTabGuard);
